import React, { Component } from 'react';

import MapContainer from './MapContainer';
import SidebarContainer from './SidebarContainer';
import LoadingOverlayContainer from './LoadingOverlayContainer'
import Banner from './Banner'

import './resizer.css'

class App extends Component {
  render () {
    const styles = { height: '100%', width: '100%' }
    return (
      <div style={styles}>
        <div style={styles}>
          <LoadingOverlayContainer />
          <Banner />
          <SidebarContainer />
          <MapContainer />
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js